import React, { useContext, useRef, useMemo } from "react";
import { AuthFunctionsContext } from "State/AuthFunctionsContext";
import ReCaptchaComponent from "Components/Common/ReCaptchaComponent";
import SbInput from "uiCore/SbInput/SbInput";
import SbButton from "uiCore/SbButton/SbButton";
import {
  FormStyled,
  FieldStyled,
  LabelStyled,
  LinksRowStyled,
  LinkStyled,
  MessageStyled,
} from "Pages/SbAuthPage/LoginV2.styles";

// Renders only the login form — the bg/logo/heading/image is provided by LoginPageLayout.
const SbLoginComponent = () => {
  const {
    username,
    setUsername,
    password,
    setPassword,
    error,
    sb_auth_handleLogin,
    sb_auth_handleBlur,
    loadingAuth,
    toggleSignup,
    toggleForgotPassword,
    authStatus,
    captchaToken,
    setCaptchaToken,
  } = useContext(AuthFunctionsContext);

  const recaptchaRef = useRef(null);
  const isRecaptchaEnabled = process.env.REACT_APP_RECAPTCHA_ENABLED !== "false";
  const handleCaptchaChange = (token) => setCaptchaToken(token);

  const isPasswordValid = useMemo(() => {
    if (!password) return false;
    const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[~!@#$%^&*])[A-Za-z\d~!@#$%^&*]{8,12}$/;
    return regex.test(password);
  }, [password]);

  const handleForgotPasswordClick = (e) => {
    e.preventDefault();
    toggleForgotPassword();
  };

  return (
    <FormStyled onFinish={() => sb_auth_handleLogin(undefined, recaptchaRef)}>
      {authStatus && <MessageStyled $success>{authStatus}</MessageStyled>}

      <FieldStyled>
        <LabelStyled htmlFor="email">Business Email</LabelStyled>
        <SbInput
          id="email"
          type="email"
          value={username}
          onBlur={sb_auth_handleBlur}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        {error.username && <MessageStyled>{error.username}</MessageStyled>}
      </FieldStyled>

      <FieldStyled>
        <LabelStyled htmlFor="password">Password</LabelStyled>
        <SbInput
          id="password"
          type="password"
          value={password}
          onBlur={sb_auth_handleBlur}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {error.password && <MessageStyled>{error.password}</MessageStyled>}
      </FieldStyled>

      <ReCaptchaComponent ref={recaptchaRef} onChange={handleCaptchaChange} theme="dark" />
      {error.captcha && <MessageStyled>{error.captcha}</MessageStyled>}
      {error.authfail && (
        <MessageStyled dangerouslySetInnerHTML={{ __html: error.authfail }} />
      )}

      <SbButton
        buttonType="accent"
        htmlType="submit"
        loading={loadingAuth}
        disabled={!isPasswordValid || (isRecaptchaEnabled && !captchaToken)}
      >
        Sign in
      </SbButton>

      <LinksRowStyled>
        <span>
          Don't have an account?{" "}
          <LinkStyled onClick={toggleSignup}>Sign up!</LinkStyled>
        </span>
        <LinkStyled onClick={handleForgotPasswordClick}>Forgot password?</LinkStyled>
      </LinksRowStyled>
    </FormStyled>
  );
};

export default SbLoginComponent;
